// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__75mVV","info":"Note_info__1EVJ6","note":"Note_note__29ucD","actions":"Note_actions__PukSf"};